// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DatabaseIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DatabaseIcon" ref={forwardedRef} {...props}>
      <path d="M4.5 5.5v9H6v-2.071c1.003.662 2.424 1.07 4 1.07s2.997-.408 4-1.07V14.5h1.5v-9C15.5 3.567 13.037 2 10 2S4.5 3.567 4.5 5.5m8.583 1.21C12.363 7.167 11.277 7.5 10 7.5S7.636 7.168 6.916 6.71C6.178 6.24 6 5.775 6 5.5s.178-.74.916-1.21C7.636 3.833 8.722 3.5 10 3.5c1.277 0 2.363.332 3.083.79C13.821 4.76 14 5.225 14 5.5s-.178.74-.916 1.21M14 7.901V10h-.002L14 10.051c0 .269-.17.719-.905 1.176C12.378 11.675 11.288 12 10 12s-2.377-.324-3.096-.772C6.17 10.77 6 10.32 6 10.051L6.002 10H6V7.902C7.003 8.578 8.424 9 10 9s2.997-.422 4-1.098" />
      <path d="M6 14.5H4.5v.005a2.46 2.46 0 0 0 .45 1.385C5.797 17.133 7.74 18 10 18s4.204-.868 5.05-2.11a2.46 2.46 0 0 0 .45-1.39H14c0 .276-.178.74-.916 1.21-.72.458-1.806.79-3.084.79s-2.364-.332-3.084-.79C6.178 15.24 6 14.776 6 14.5" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DatabaseIcon = /* @__PURE__ */ Object.assign(
  DatabaseIconComponent,
  { displayName: 'DatabaseIcon' },
);
